import React from 'react';

interface IProps {
  style?: any;
}

const ErrorIcon:React.FC<IProps> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" style={props.style} width="22" height="23" fill="none" viewBox="0 0 22 23">
      <circle cx="11" cy="12" r="8" fill="#E6D863"/>
      <path fill="#122442" fillRule="evenodd" d="M10 14.65V7.768h2v6.884h-2zM10 16.225v-1.048h2v1.048h-2z" clipRule="evenodd"/>
    </svg>
  )
}

export default ErrorIcon;